
import SignUpCover from "./signup";

export default function SignUpCoverPage() {
  return <SignUpCover />;
}
